"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderLineIcon = void 0;
const getOrderLineIcon = (type) => {
    switch (type) {
        case "GOLF": {
            return "https://golfsavers.b-cdn.net/assets/icons/golf_icon.png";
        }
        case "TRANSFER": {
            return "https://golfsavers.b-cdn.net/assets/icons/transfer_icon.png";
        }
        case "HOTEL": {
            return "https://golfsavers.b-cdn.net/assets/icons/hotel_icon.png";
        }
        case "CUSTOM": {
            return "https://golfsavers.b-cdn.net/assets/icons/custom_icon.png";
        }
    }
};
exports.getOrderLineIcon = getOrderLineIcon;
